/**
 * The id of the default layout that is automatically generated.
 */
export const DEFAULT_LAYOUT_ID = "default";

/**
 * The name to display for the default view that shows everything.
 */
export const DEFAULT_VIEW_NAME = "All Artifacts";

/**
 * The status code for a session timeout.
 */
export const LOGOUT_STATUS_CODE = 401;

/**
 * The error message for a logout error.
 */
export const LOGOUT_ERROR = "Session has timed out. Please log back in.";

/**
 * The amount of nodes at which we need to do graph optimizations.
 */
export const LARGE_NODE_COUNT = 200;

/**
 * The max amount of nodes before the layout will be regenerated by the
 * server and not locally.
 */
export const LARGE_NODE_LAYOUT_COUNT = 50;

/**
 * The demo user's account.
 */
export const DEMO_ACCOUNT = {
  email: process.env.VUE_APP_DEMO_EMAIL || "",
  password: process.env.VUE_APP_DEMO_PW || "",
};

export const DEMO_VERSION_ID = process.env.VUE_APP_DEMO_PROJECT || "";
